/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const globalVarActions = Reflux.createActions([
	'paramChange',
	'useStoreChange'
]);

export class globalVarStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
			useStore: false,
			storeData:{
				s: 10,
				p: 1,
				sKey:'',
				active:'',
				name:''
			}
		}
		this.listenables = globalVarActions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			storeData:{
				...this.state.storeData,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/globalVar/store.js